  /* Checks if the file is a RepX type so that the name is verified.
    The name should be checked so the correct data is saved on the formatted Data in the CSV
    */

export const generateNameIfNoInputtedName = (
  initialFileName,
  inputtedFileName,
  setInputtedFileName,
  isNewSnapshot
) => {

  const date = Date.now();
  let newName = "";
  let snapshotName = localStorage.getItem("selectedSnapshot");
  let isRepX = snapshotName && snapshotName.toLowerCase().includes("repx");

  //If it's a RepX and the user specified a name
  if (isRepX && inputtedFileName.trim() !== "") {
    newName = `repx_${inputtedFileName}`;

    //If it's a RepX and the user didn't specify a name
  } else if (isRepX && !inputtedFileName && initialFileName != snapshotName) {
    newName = `repx_${initialFileName}_${date}`;

    //If it's a regular Snapshot and the user specified a name
  } else if (!isRepX && inputtedFileName.trim() !== "") {
    newName = `${inputtedFileName}`;

    //If it's a regular Snapshot and the user didn't specified a name
  } else if (!isRepX && !inputtedFileName && initialFileName != snapshotName) {
    newName = `${initialFileName}_${date}`;

    //If the Snapshot is not a new Snapshot created from a template and the user did not specify the name and wants to save it under the same name
  } else if (
    !isNewSnapshot &&
    !inputtedFileName &&
    initialFileName === snapshotName
  ) {
    newName = `${initialFileName}`;

    //If the Snapshot new (created from a template) and the user did not specify the name and wants to save it under the same name
  } else if (
    isNewSnapshot &&
    !inputtedFileName &&
    initialFileName === snapshotName
  ) {
    newName = `${initialFileName}_${date}`;
  } else {
    newName = inputtedFileName;
  }
  console.log("newName in generation: ", newName);
  setInputtedFileName(newName);
  return newName;
};
